import {
  Component,
  Input,
  ChangeDetectionStrategy,
  HostBinding,
} from '@angular/core';
import { Token } from '@cigna/resource-content/contracts';
import { Renderer } from './renderer.interface';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'a',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkRendererComponent implements Renderer {
  @Input() token: Token;

  @HostBinding('attr.href')
  get href() {
    return this.token[2];
  }

  @HostBinding('attr.target')
  get target() {
    return this.token[3];
  }

  @HostBinding('attr.class')
  get class() {
    return this.token[4];
  }
}
